// Any config specific to Georgia?

export default {
  code: 'AM',
  countryName: 'Armenia',
  // googleSiteVerificationCode: '1uUi471agIlOfQQ3ns5BSv78-YAYOVbuPdRyGUsfq2I',
  googleSiteVerificationCode: ['X1B_9GgrzG2rdOXBoOKgIif4kvi8_HixLZ0Ouh6Hd3E'],
  countryDomain: 'https://www.carrefour.am',
  helplineNumber: '800 73232',
  latitude: 30.1279,
  longitude: 31.33,
  defaultAreaCode: 'Didi Dighomi - Tbilisi',
  features: {
    languageChange: true,
    now: true,
    share: true,
    isLocationCXEnable: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: '34776a4f-83e0-4002-8c11-76d4c3a1764f'
  }
}
